
// Modules
import { Attachments } from './attachments';
import { profile } from './profile';
import { settings } from './settings';

export const store = {
  Attachments,
  profile,
  settings
};


export const vstore = {
  install(v: any) {
    v.mixin({
      beforeCreate: function () {
        this.$vstore = store;
      }
    });

  }
};


export default store;
